export default __webpack_public_path__ + "static/media/ninacover.f279cf10.jpg";